import { ASSET_PREFIX } from 'utils/constants';

import { SocialLink } from './SocialLink';
import styles from './SocialLinkSection.module.css';

export const SocialLinkSection = () => {
  return (
    <div className={styles.socialLinkSection}>
      <p className={styles.heading}>Follow us</p>
      <div className={styles.iconRow}>
        <SocialLink
          id="facebookext"
          href="https://www.facebook.com/daymadeuk/"
          image={`${ASSET_PREFIX}/images/social-media-icons/facebook-circle.svg`}
          alt="Facebook icon"
        />

        <SocialLink
          id="instagramext"
          href="https://www.instagram.com/daymadeuk/"
          image={`${ASSET_PREFIX}/images/social-media-icons/instagram-circle.svg`}
          alt="Instagram icon"
        />

        <SocialLink
          id="youtubeext"
          href="https://www.youtube.com/channel/UCUVOk8dVM_mu-1qgKwtn9HA"
          image={`${ASSET_PREFIX}/images/social-media-icons/youtube-circle.svg`}
          alt="YouTube icon"
        />

        <SocialLink
          id={'tiktokext'}
          href={'https://www.tiktok.com/@daymadeuk'}
          image={`${ASSET_PREFIX}/images/social-media-icons/tiktok-circle.svg`}
          alt="TikTok icon"
        />
      </div>
    </div>
  );
};
